export type CountdownParts = {
  days: number;
  hours: number;
  minutes: string;
  seconds: string;
} | null;

export type CountdownDisplay =
  | { kind: 'clock'; time: string }
  | { kind: 'withDays'; days: number; time: string };

const CLOCK_FALLBACK = '00:00:00';

const toClock = ({ hours, minutes, seconds }: NonNullable<CountdownParts>) =>
  `${hours.toString().padStart(2, '0')}:${minutes}:${seconds}`;

export function getCountdownDisplay(countdown: CountdownParts): CountdownDisplay {
  if (!countdown) return { kind: 'clock', time: CLOCK_FALLBACK };
  const time = toClock(countdown);
  if (countdown.days > 0) return { kind: 'withDays', days: countdown.days, time };
  return { kind: 'clock', time };
}

export const isSingleDayCountdown = (display: CountdownDisplay): boolean =>
  display.kind === 'withDays' && display.days === 1;
